import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ListData, ListFilter, sortList } from 'src/app/features/restaurants/models/Floors';
import { RestaurantDetails } from 'src/app/features/restaurants/models/List.Restaurant';
import { FloorsService } from 'src/app/features/restaurants/services/Floors.service';
import { RestaurantService } from 'src/app/features/restaurants/services/Restaurant.service';
import Swal from 'sweetalert2';
import { FloorFormComponent } from './floor-form/floor-form.component';

@Component({
  selector: 'app-floors-management',
  templateUrl: './floors-management.component.html'
})
export class FloorsManagementComponent implements OnInit {

  dataLoading = true;
  showFilter = false;
  showSearch = false;
  pageIndex = 0;
  pageCount = 0;
  pageSize = 10;
  recordsData!: ListData | null;
  filterModel: ListFilter = new ListFilter();

  filterFormGroup: FormGroup = new FormGroup({});
  today = new Date();

  sortItemSelected!: sortList;
  sortItems = [
    { name: this.translate.instant('content.Name'), value: sortList.Name },
    { name: this.translate.instant('forms.Recently added'), value: sortList.NewestCreate },
    { name: this.translate.instant('content.Oldest added'), value: sortList.OldestCreate },
    { name: this.translate.instant('content3.Highest used'), value: sortList.HighestUse },
    { name: this.translate.instant('content3.Lowest used'), value: sortList.LowestUse },
    { name: this.translate.instant('content3.Highest Amount'), value: sortList.Highest_Amount },
    { name: this.translate.instant('content3.Lowest Amount'), value: sortList.Lowest_Amount },

  ];
  // Restaurant ID
  restaurantId?: any;
  allRestaurants: RestaurantDetails[] = [];
  restaurantData: any;

  lang = localStorage.getItem('language') || 'en';

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public translate: TranslateService,
    private service: FloorsService,
    private formBuilder: FormBuilder,
    private restaurantService: RestaurantService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.filterModel.sortItems = sortList.NewestCreate;
    this.buildFilterForm()
    this.filterModel.pageSize = this.pageSize;
  }

  GetRestaurantShortDetails(restaurantId: any) {
    this.restaurantService.GetRestaurantShortDetails(restaurantId).subscribe((data: any) => {
      this.restaurantData = data
    })
  }

  buildFilterForm() {
    this.filterFormGroup = this.formBuilder.group({
      createdFrom: [null],
      createdTo: [null],
    });
  }

  getAll(event: any, restId?: any) {
    this.dataLoading = true;
    if (restId && restId != this.restaurantId) {
      this.restaurantId = restId;
      event = false;
    }
    if (!event) {
      this.filterModel.pageNumber = 0;
      this.filterModel.pageSize = this.pageSize;
    }
    if (event && event.pageSize) {
      this.pageIndex = event.pageIndex;
      this.filterModel.pageSize = event.pageSize;

    }
    this.filterModel.restaurantId = this.restaurantId;
    this.filterModel.pageNumber = this.pageIndex;

    this.service.getAll(this.filterModel).subscribe(
      (data: ListData) => {
        this.dataLoading = false;
        if (data) {
          this.recordsData = data;
          this.pageCount = Math.ceil(this.recordsData.totalCount / this.filterModel.pageSize);
        }
      },
      (error: any) => {
        this.recordsData = null;
        this.dataLoading = false;
      });
  }

  changePagingParams() {
    const queryParams: Params = {
      page: this.filterModel.pageNumber,
      pageSize: this.filterModel.pageSize
    };
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  counter(i: number) { return new Array(i); }

  openForm(record: any | null = null) {
    const dialogRef = this.dialog.open(FloorFormComponent, {
      width: '50rem',
      data: { record, restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAll(true, this.restaurantId);
      }
    });
  }

  deleteRecord(recordId: number) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        this.service.delete(recordId).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.deletededsuccessfuly'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAll(true, this.restaurantId);
            }
          },
          (error: any) => {
            this.dataLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          });
      }
    });
  }

  changeStatus(status: boolean, recordId: number) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        this.service.activeDeactiveFloor(recordId, status).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.updatedsuccessfully'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAll(true, this.restaurantId);
            }
          },
          (error: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          })
      }
    });
  }


  makeSearch() {
    if (!this.showSearch) {
      this.showSearch = true; // Show input
    } else {
      if (this.filterModel.searchText) {
        this.getAll(true, this.restaurantId);
      }
    }
  }

  resetSearch() {
    this.filterModel.searchText = '';
    this.getAll(true, this.restaurantId);
  }

  makeFilter() {
    const controls = this.filterFormGroup.controls;
    this.filterModel.createdFrom = controls['createdFrom'].value;
    this.filterModel.createdTo = controls['createdTo'].value;

    this.getAll(true, this.restaurantId);
  }

  clearFilter() {
    this.filterModel = new ListFilter();
    this.filterModel.sortItems = sortList.NewestCreate;
    this.filterModel.pageSize = this.pageSize;
    this.getAll(true, this.restaurantId);
    this.filterFormGroup.reset();
  }

  ////////////////////////////////////////////

  GetScreenData() {
    this.getAll(null, this.restaurantId)
    this.GetRestaurantShortDetails(this.restaurantId);
  }
}
